<template>
  <div class="loading-overlay" v-if="isVisible">
    <div class="spinner">
      <svg viewBox="0 0 50 50">
        <circle class="ring" cx="25" cy="25" r="20"></circle>
        <circle class="segment" cx="25" cy="25" r="20" :stroke-dasharray="circumference" :stroke-dashoffset="offset"></circle>
      </svg>
      <div class="percentage">{{ percentage }}%</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    percentage: {
      type: Number,
      required: true
    },
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    circumference() {
      return 2 * Math.PI * 20;
    },
    offset() {
      return this.circumference - (this.percentage / 100) * this.circumference;
    }
  }
}
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
}

svg {
  width: 100px;
  height: 100px;
}

.ring {
  fill: none;
  stroke: #e0e0e0;
  stroke-width: 4;
}

.segment {
  fill: none;
  stroke: #76c7c0;
  stroke-width: 4;
  transition: stroke-dashoffset 0.3s ease;
}

.percentage {
  margin-top: 10px;
  font-size: 18px;
  color: #fff;
}
</style>
